import { Grid, Tooltip} from "@mui/material";

export function getProductStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        description:{
            name:'description',
            label:'Description',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        imagepath:{
            name:'imagepath',
            label:'Image Path',
            value:'',
            error:false,
            errorMessage:'You must enter Image Path',
            required:true,
            fieldtype:'string'
        },
        price:{
            name:'price',
            label:'Price',
            value:'',
            error:false,
            errorMessage:'You must enter Price',
            required:true,
            fieldtype:'double'
        },
        discountpercentile:{
            name:'discountpercentile',
            label:'Discount Percentile',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        statusid:{
            name:'statusid',
            label:'Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        invqty:{
            name:'invqty',
            label:'Inv Qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        seqid:{
            name:'seqid',
            label:'Seq Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        gstpercentile:{
            name:'gstpercentile',
            label:'GST Percentile',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:150 },
        { field: 'description', headerName: 'Description', width:150 },
        { field: 'imagepath', headerName: 'Image Path', width:150 },
        { field: 'price', headerName: 'Price', width:150 },
        { field: 'discountpercentile', headerName: 'Discount Percentile', width:150 },
        { field: 'statusid', headerName: 'Status Id', width:150 },
        { field: 'invqty', headerName: 'Inv Qty', width:150 },
        { field: 'seqid', headerName: 'Seq Id', width:150 },
        { field: 'gstpercentile', headerName: 'GST Percentile', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['description']:{
          ...formValues['description'],
          value:data.description,
        },['imagepath']:{
          ...formValues['imagepath'],
          value:data.imagepath,
        },['price']:{
          ...formValues['price'],
          value:data.price,
        },['discountpercentile']:{
          ...formValues['discountpercentile'],
          value:data.discountpercentile,
        },['statusid']:{
          ...formValues['statusid'],
          value:data.statusid,
        },['invqty']:{
          ...formValues['invqty'],
          value:data.invqty,
        },['seqid']:{
          ...formValues['seqid'],
          value:data.seqid,
        },['gstpercentile']:{
          ...formValues['gstpercentile'],
          value:data.gstpercentile,
        },
      })
}